// extracted by mini-css-extract-plugin
module.exports = {"simpleLabel":"toolbarselects_simpleLabel__KEM5w","choiceBoxes":"toolbarselects_choiceBoxes__2F5j0","simpleField":"toolbarselects_simpleField__2haQb"};